import { client } from '@xFrame4/business/GraphQlClient';
import { BusinessEntityFieldType } from '@xFrame4/business/base/Constants';
import { imageInfoGraphQlDetails } from '@xFrame4/business/Constants';
import { YouTubeVideoInfo, ImageInfo } from '@xFrame4/business/Types';
import ImageGallery, { GalleryImage } from '@xFrame4/business/images/ImageGallery';
import CompanyGenerated, { CompanyGeneratedEntityManager } from './generated/Company.generated';
import { CompanyTranslation } from './CompanyTranslation';


export class CompanyEntityManager extends CompanyGeneratedEntityManager<CompanyTranslation, Company>
{
    constructor()
    {
        super({
            createEntity: () => new Company(),
            fields: [
                { name: 'hasImage', type: BusinessEntityFieldType.Boolean, isInput: false },
                { name: 'image', type: BusinessEntityFieldType.Custom, inputProperty: 'imageFile', customGraphQl: imageInfoGraphQlDetails }, // Logo image for the company
            ]
        });
    }
}


export class Company extends CompanyGenerated<CompanyTranslation>
{
    static _manager: CompanyEntityManager;
    static get manager(): CompanyEntityManager
    {
        if (!this._manager) this._manager = new CompanyEntityManager();
        return this._manager;
    }

    /** Whether the entity has an image file stored in the media folder. */
    hasImage: boolean = false;
    /** The logo image for the company */
    image!: ImageInfo;
    /** The file to upload for the logo image */
    imageFile?: File;

    /**
     * Get the company from the database.
     * @returns The company. It should always exist.
     */
    static async getTheCompany(): Promise<Company>
    {
        // Dynamically import the gql to speed up the initial loading
        const { gql } = await import('@apollo/client');

        let query = `
            query GetTheCompany {
                theCompany {
                    ...CompanyDetailsFragment
                }
            }
            ${Company.manager.buildEntityDetailsFragment()}
        `;

        let { data } = await client.query({
            query: gql(query),
        });

        return Company.manager.createFromGraphQL(data.theCompany) as Company;
    }
}


export default Company;